export default {
    gray:               'gray',
    graySmall:          'graySmall',
    graySlim:           'graySlim',
    graySmallFullWidth: 'graySmallFullWidth',
    yellow:             'yellow',
    yellowSmall:        'yellowSmall',
};